import $ from "jquery";
import WKT from "ol/format/WKT";
import { Image as ImageLayer, Vector as VectorLayer } from "ol/layer";
import { transform } from "ol/proj";
import { ImageWMS, Vector as VectorSource } from "ol/source";
import { containsXY } from "ol/extent";
import * as olStyle from "ol/style";
import React from "react";
import ReactDOM from "react-dom";
//import {BsPlus, BsDash} from "react-icons/bs";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { RiDeleteBin2Line } from "react-icons/ri";
import { createAction, handleActions } from "redux-actions";
import SisOverlay from "store/sis/SisOverlay";
import SisMap from "./SisMap";
import SisLayer from "store/sis/SisLayer";

// 액션 타입을 정의해줍니다.
const LOAD_MAP = "LOAD_MAP";
const UPDATE_SIZE = "UPDATE_SIZE";
// 메인 부동산 정보조회 이동
const SEARCH_PNU = "SEARCH_PNU";


// 액션 생성 함수를 만듭니다.
export const loadMap = createAction(LOAD_MAP);
export const updateSize = createAction(UPDATE_SIZE);
export const searchPnu = createAction(SEARCH_PNU);

const initialState = {
	sisMap: null,
	crsCode: "EPSG:3857",
	lstSgg: [],
	sggSelectList: [],
	defaultSggCd: "12330",
	category: "",
	pnu: "",
};

export default handleActions(
	{
		[LOAD_MAP]: (state, action) => {
			const sisMap = new SisMap(action.payload);
			const sisLayer = new SisLayer(sisMap.map);

			if (sisMap.x && sisMap.y && sisMap.z) {
				sisMap.view.setCenter([parseFloat(sisMap.x), parseFloat(sisMap.y)]);
				sisMap.view.setZoom(sisMap.z);
			}			

			return {
				...state,
				sisMap,
				sisLayer,
			};
		},
		[UPDATE_SIZE]: (state, action) => {
			setTimeout(() => {
				state.sisMap.map.updateSize();
			}, action.payload);

			return state;
		},
	},
	initialState
);
